/**
 * Comparison report vocabulary (tasks 1178, 1180): change badges, their order,
 * and how a side's outcome reads.
 */
import type { ComparisonChange, ComparisonOutcome, ComparisonRow } from '@/types/endpointTests';

export const CHANGE_LABEL: Record<ComparisonChange, string> = {
  regressed: 'regressed',
  improved: 'improved',
  unchanged: 'unchanged',
  'flipped-criterion': 'flipped criterion',
  'only-a': 'only in a',
  'only-b': 'only in b',
};

export const CHANGE_BADGE_CLASS: Record<ComparisonChange, string> = {
  regressed: 'bg-red-100 text-red-800 dark:bg-red-900/60 dark:text-red-200',
  improved: 'bg-green-100 text-green-800 dark:bg-green-900/60 dark:text-green-200',
  unchanged: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
  'flipped-criterion': 'bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-200',
  'only-a': 'bg-gray-50 text-gray-500 dark:bg-gray-800 dark:text-gray-400',
  'only-b': 'bg-gray-50 text-gray-500 dark:bg-gray-800 dark:text-gray-400',
};

/** Regressions first, then improvements, flipped criteria, unchanged, only-in-one. */
const CHANGE_ORDER: Record<ComparisonChange, number> = {
  regressed: 0,
  improved: 1,
  'flipped-criterion': 2,
  unchanged: 3,
  'only-a': 4,
  'only-b': 4,
};

export function sortComparisonRows(rows: ComparisonRow[]): ComparisonRow[] {
  return rows
    .map((row, index) => ({ row, index }))
    .sort((x, y) => CHANGE_ORDER[x.row.change] - CHANGE_ORDER[y.row.change] || x.index - y.index)
    .map((entry) => entry.row);
}

export function outcomeLabel(outcome: ComparisonOutcome | undefined): string {
  if (outcome === undefined || outcome === null) return '—';
  return outcome;
}

export function outcomeClass(outcome: ComparisonOutcome | undefined): string {
  if (outcome === 'pass') return 'text-green-700 dark:text-green-400';
  if (outcome === 'fail' || outcome === 'errored') return 'text-red-600 dark:text-red-400';
  if (outcome === 'uncertain') return 'text-amber-600 dark:text-amber-400';
  return 'text-gray-500 dark:text-gray-400';
}
